// U-1 `/upload` — deep-link fallback. Когда юзер попадает сюда напрямую
// (из Processing error / UploadHistory empty / прямой URL), сразу открываем
// bottom-sheet с выбором источника поверх пустой странички.
//
// HomeEmpty / HomeConfirmed используют <UploadSourcePicker + BottomSheet> inline —
// этот page существует только как backward-compat entry для прямых ссылок.

import { useState } from 'react';
import { useLocation } from 'wouter';
import { BottomSheet } from '@/components/ui/bottom-sheet';
import { MobileFrame } from '@/components/layout/MobileFrame';
import { UploadSourcePicker } from '@/components/uploads/UploadSourcePicker';

export function UploadSheet() {
  const [, setLocation] = useLocation();
  const [open, setOpen] = useState(true);

  const goHome = () => {
    setOpen(false);
    setLocation('/');
  };

  return (
    <MobileFrame>
      <div className="flex-1" />
      <BottomSheet open={open} onClose={goHome} ariaLabel="Выбор источника файла">
        <UploadSourcePicker
          onClose={goHome}
          onUploaded={(uploadId) => setLocation(`/upload/processing/${uploadId}`)}
          onBatchCreated={(batchId) => setLocation(`/uploads/batch/${batchId}`)}
        />
      </BottomSheet>
    </MobileFrame>
  );
}
